import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModalType, Theme, TabType } from '../../types';

interface UiState {
    isLoading: boolean;
    activeModal: ModalType;
    theme: Theme;
    activeTab: TabType;
}

const getInitialTheme = (): Theme => {

    if (window.Telegram?.WebApp?.colorScheme) {
        const telegramTheme = window.Telegram.WebApp.colorScheme === 'dark' ? 'dark' : 'light';
        console.log('🎨 Тема из Telegram:', telegramTheme);
        return telegramTheme;
    }


    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        console.log('🎨 Темная тема из системы');
        return 'dark';
    }

    console.log('🎨 Светлая тема по умолчанию');
    return 'light';
};

const initialState: UiState = {
    isLoading: true,
    activeModal: null,
    theme: getInitialTheme(),
    activeTab: 'map',
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        openModal: (state, action: PayloadAction<ModalType>) => {
            state.activeModal = action.payload;
        },
        closeModal: (state) => {
            state.activeModal = null;
        },
        setTheme: (state, action: PayloadAction<Theme>) => {
            state.theme = action.payload;
            console.log('🎨 Тема изменена пользователем:', action.payload);
        },
        setActiveTab: (state, action: PayloadAction<TabType>) => {
            state.activeTab = action.payload;
        },
    },
});

export const {
    setLoading,
    openModal,
    closeModal,
    setTheme,
    setActiveTab,
} = uiSlice.actions;

export const uiSlices = uiSlice.reducer;